import { getRoles } from "../services/roleService";

export async function prefetchRoles() {
  try {
    await getRoles();
    return true;
  } catch {
    return false;
  }
}

export async function getRoleNameById(roleId) {
  const roles = await getRoles();
  const idNum = Number(roleId);
  if (!Number.isInteger(idNum)) return null;
  const r = roles.find((x) => Number(x?.role_id) === idNum);
  return r?.name || null;
}

export function isAdminRoleName(roleName) {
  return (
    String(roleName || "")
      .trim()
      .toUpperCase() === "ADMIN"
  );
}

export async function resolveRoleName(user) {
  // Prefer role fields directly from auth payload to avoid extra API calls
  if (user) {
    const direct = [
      user.role,
      user.role_name,
      user.roleName,
      user.role?.name,
      user.role?.role_name,
    ].map((v) => (v == null ? null : String(v)));
    const picked = direct.find((v) => v && v.trim().length > 0);
    if (picked) return picked;
  }
  return null;
}

// Company of the logged-in user, from the user info stored at login (/auth/me).
export function getCurrentUserCompanyId() {
  try {
    const user = JSON.parse(sessionStorage.getItem("auth") || "null")?.user;
    return (
      user?.company_id ?? user?.companyId ?? user?.company?.company_id ?? null
    );
  } catch {
    return null;
  }
}
